/* eslint-disable no-nested-ternary */
import React from 'react'
import _ from 'lodash'
import swalAlert from './swalAlert'
import { ROWS_PER_PAGE_DEFAULT } from '../constants/common'

export const parseProduct = (product) => {
  // TODO: translate
  const combustibles = {
    1: 'GOA', // Gasóleo A
    2: 'Gasóleo B',
    3: 'Gasóleo C',
    4: 'Bio Diésel',
    5: 'G95', // SPlomo 95
    6: 'GOAPLUS', // Súper 97
    7: 'AdBlue', //AdBlue surtidor
    8: 'Gasóleo A ESP',
    9: 'SPlomo 98',
  }
  return combustibles[product] || ''
}

export const getRowsPerPage = (limitInitial) => {
  if (limitInitial && !ROWS_PER_PAGE_DEFAULT.includes(limitInitial)) {
    return _.orderBy([...ROWS_PER_PAGE_DEFAULT, limitInitial], [], ['asc'])
  }
  return _.orderBy(ROWS_PER_PAGE_DEFAULT, [], ['asc'])
}

export const getDataCountDisplayPerPage = ({ limit, rowsPerPageOptions }) => {
  return (
    limit ||
    (rowsPerPageOptions ? rowsPerPageOptions[1] : getRowsPerPage(limit)[1])
  )
}

export const formatFuelQuantity = (value, styled = false) => {
  const procValue =
    value !== null && value !== undefined
      ? Number(value).toLocaleString('de-DE')
      : ''
  const suffix = ' /m³'
  return procValue ? (
    // eslint-disable-next-line no-nested-ternary
    styled ? (
      <>
        <span>{value !== null && value !== undefined ? procValue : ''}</span>
        <span style={{ opacity: 0.6, fontSize: '90%' }}>{suffix}</span>
      </>
    ) : value !== null && value !== undefined ? (
      procValue.concat(suffix)
    ) : (
      ''
    )
  ) : (
    ''
  )
}

export const formatCurrency = (value, options = {}, styled) => {
  const procValue =
    value !== null && value !== undefined
      ? Number(value).toLocaleString('de-DE', {
          style: !styled ? 'currency' : undefined,
          currency: !styled ? 'EUR' : undefined,
          minimumFractionDigits: 3,
          maximumFractionDigits: 3,
          ...options,
        })
      : ''
  const suffix = ' €'
  return procValue ? (
    styled ? (
      <span style={{ whiteSpace: 'nowrap' }}>
        <span>{value !== null && value !== undefined ? procValue : ''}</span>
        <span style={{ opacity: 0.6, fontSize: '90%' }}>{suffix}</span>
      </span>
    ) : value !== null && value !== undefined ? (
      procValue
    ) : (
      ''
    )
  ) : (
    ''
  )
}

// eslint-disable-next-line no-unused-vars
export const formatPercent = (value, options = {}) => {
  return value !== null && value !== undefined
    ? // El formato alemán incluye el punto en importes de miles
      Number(value / 100).toLocaleString('de-DE', {
        style: 'percent',
        minimumFractionDigits: 3,
        maximumFractionDigits: 3,
      })
    : ''
}

export const formatNumber = (value) => {
  return value !== null && value !== undefined
    ? // El formato alemán incluye el punto en importes de miles
      Number(value).toLocaleString('de-DE', {
        style: 'decimal',
        minimumFractionDigits: 3,
        maximumFractionDigits: 3,
      })
    : ''
}

export const formatUnits = (value) => {
  return value !== null && value !== undefined
    ? // El formato alemán incluye el punto en importes de miles
      Number(value).toLocaleString('de-DE', {
        style: 'decimal',
      })
    : ''
}

export const confirmAction = async ({
  action,
  areYouSureMsg,
  yesMsg,
  noMsg,
}) => {
  const confirm = await swalAlert.warning(areYouSureMsg, noMsg, yesMsg)
  let resp

  if (confirm?.isConfirmed) {
    resp = await action()
    return resp
  }
  return null
}
